import React, { useState } from "react";

//UI Material
import {
  Alert,
  Button,
  IconButton,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

//Material Icons
import { AddCircle, ArrowForwardIos, RemoveCircle } from "@mui/icons-material";

//Local components
import NewItemEntryDrawer from "../drawers/NewItemEntryDrawer";
import NewItemStockoutDrawer from "../drawers/NewItemStockoutDrawer";

export default function ItemRow({
  item,
  getData,
  suppliersList = [],
  needsStockAlert = false,
}) {
  // ==========>Component States<==========
  //State for open/close drawer for entry creation
  const [openEntryDrawer, setOpenEntryDrawer] = useState(false);
  //State for open/close drawer for stockout creation
  const [openStockoutDrawer, setOpenStockoutDrawer] = useState(false);

  return (
    <TableRow>
      <NewItemEntryDrawer
        data={item}
        getData={getData}
        open={openEntryDrawer}
        setOpen={setOpenEntryDrawer}
        suppliersList={suppliersList}
      />
      <NewItemStockoutDrawer
        data={item}
        getData={getData}
        open={openStockoutDrawer}
        setOpen={setOpenStockoutDrawer}
      />
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{item.id}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{item.name}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{item.location}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          justifyContent="center"
        >
          <IconButton
            onClick={() => {
              setOpenStockoutDrawer(true);
            }}
          >
            <RemoveCircle color="error" />
          </IconButton>
          <Typography variant="body2">{item.availableStock}</Typography>
          <IconButton
            onClick={() => {
              setOpenEntryDrawer(true);
            }}
          >
            <AddCircle color="success" />
          </IconButton>
        </Stack>
        {needsStockAlert && (
          <Alert severity="error">{`Stock es recomendado: ${item.recommendedStock}`}</Alert>
        )}
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">
          {item.lastEntry ? new Date(item.lastEntry).toLocaleString() : ""}
        </Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">
          {item.lastStockout
            ? new Date(item.lastStockOut).toLocaleString()
            : ""}
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Button
          size="small"
          variant="contained"
          color="secondary"
          sx={{ color: "white" }}
          endIcon={<ArrowForwardIos />}
          onClick={() => {
            window.location.href = `/item?id=${item.id}`;
          }}
        >
          Ver ítem
        </Button>
      </TableCell>
    </TableRow>
  );
}
